// extracted by mini-css-extract-plugin
export default {"eventInfo":"V0dKtH","multiDay":"sfwbOU","time":"WPczEB","title":"ExCBIq"};